import { LcQuote } from '../hooks/useLiquidityCacheQuote';

interface NiceModeAlertProps {
  quote: LcQuote;
  inputSymbol: string;
  outputSymbol: string;
}

export function NiceModeAlert({ quote, inputSymbol, outputSymbol }: NiceModeAlertProps) {
  if (!quote.niceMode || quote.niceMode.roundingSavings === '0') return null;

  return (
    <div className="rounded-md border border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950 p-3 text-sm">
      <p className="font-medium text-green-800 dark:text-green-200">Nice Mode Active</p>
      <p className="text-green-700 dark:text-green-300 mt-1">
        Input reduced from original to {quote.niceMode.adjustedInput} {inputSymbol} to produce a
        clean output of {quote.niceMode.cleanOutput} {outputSymbol}.
      </p>
      <p className="text-green-600 dark:text-green-400 mt-1">
        You save {quote.niceMode.roundingSavings} {inputSymbol} in rounding.
      </p>
    </div>
  );
}
